var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55.891,
  height: 55.892,
  viewBox: "0 0 55.891 55.892"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M55.073 7.314h-8.024a.819.819 0 1 0 0 1.637h7.2v30.02H1.637V8.951h7.2a.819.819 0 1 0 0-1.637H.819A.82.82 0 0 0 0 8.133V46.34a.82.82 0 0 0 .819.819h18.667v1.768l-1.747 2.052h-6.714a2.456 2.456 0 0 0 0 4.912h33.841a2.456 2.456 0 0 0 0-4.912h-6.7l-1.758-2.2v-1.623h18.665a.82.82 0 0 0 .819-.819V8.133a.82.82 0 0 0-.819-.819m-9.388 46.121a.82.82 0 0 1-.819.819H11.025a.819.819 0 1 1 0-1.637h33.841a.82.82 0 0 1 .819.819ZM34.948 49.58l1.12 1.4H19.891l1.038-1.222a.82.82 0 0 0 .194-.525v-2.074h13.645v1.91a.82.82 0 0 0 .179.512Zm-33.31-4.06v-4.912h52.616v4.912Z",
  "data-name": "Path 858"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M31.221 42.246h-6.55a.819.819 0 0 0 0 1.638h6.55a.819.819 0 0 0 0-1.638",
  "data-name": "Path 859"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M11.299 0v5.458h33.295V0Zm26.472 3.548h-.546a.819.819 0 1 1 0-1.637h.546a.819.819 0 0 1 0 1.637m4.367 0h-.546a.819.819 0 0 1 0-1.637h.546a.819.819 0 0 1 0 1.637",
  "data-name": "Path 860"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M24.715 18.106a3.548 3.548 0 1 1 6.462 0 8.55 8.55 0 0 1 3.229 2.363 6.823 6.823 0 1 0-12.921 0 8.55 8.55 0 0 1 3.23-2.363",
  "data-name": "Path 861"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1.91,
  cy: 1.91,
  r: 1.91,
  fill: "#7654fd",
  "data-name": "Ellipse 24",
  transform: "translate(26.035 14.737)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M30.109 19.457a3.54 3.54 0 0 1-4.325 0 6.9 6.9 0 0 0-3.487 2.649 6.817 6.817 0 0 0 11.3 0 6.9 6.9 0 0 0-3.488-2.649",
  "data-name": "Path 862"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M35.314 30.238h4.912v2.729h-4.912z",
  "data-name": "Rectangle 126"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M15.665 30.238h18.012v2.729H15.665z",
  "data-name": "Rectangle 127"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M11.299 37.334h33.295V7.096H11.299ZM27.946 9.825a8.46 8.46 0 1 1-8.46 8.46 8.46 8.46 0 0 1 8.46-8.46M14.028 29.42a.82.82 0 0 1 .819-.819h26.2a.82.82 0 0 1 .819.819v4.366a.82.82 0 0 1-.819.819h-26.2a.82.82 0 0 1-.819-.819Z",
  "data-name": "Path 863"
})));
export default SvgLogin;